import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { SortDirection } from '@/hooks/use-server-pagination'

interface SortableHeaderProps {
  label: string
  sortKey: string
  currentSortBy: string
  currentSortDir: SortDirection
  onSort: (key: string) => void
  className?: string
}

export function SortableHeader({
  label,
  sortKey,
  currentSortBy,
  currentSortDir,
  onSort,
  className,
}: SortableHeaderProps) {
  const isActive = currentSortBy === sortKey

  return (
    <span className="inline-flex items-center">
      <button
        onClick={() => onSort(sortKey)}
        className={cn(
          'flex items-center gap-1 hover:text-foreground transition-colors',
          isActive ? 'text-foreground' : 'text-muted-foreground',
          className
        )}
        data-testid={`btn-sort-${sortKey}`}
      >
        {label}
        {isActive ? (
          currentSortDir === 'asc' ? (
            <ArrowUp className="h-4 w-4" />
          ) : (
            <ArrowDown className="h-4 w-4" />
          )
        ) : (
          <ArrowUpDown className="h-4 w-4 opacity-50" />
        )}
      </button>
    </span>
  )
}
